import * as React from 'react';
import './MenuBar.scss'
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { handlePayer } from '../../functions/Cards/CardsFuncs';
import { useHistory } from 'react-router';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

//@ts-ignore
function MenuBar({ obtlist, name }) {
    let history = useHistory()
    const storedTheme = sessionStorage.getItem("theme");
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleRedirectToLogin = (link: string) => {
        history.push(link)
    }
    const handleLogo = (logo: any) => {
        sessionStorage.setItem('logo', `${process.env.REACT_APP_LOGO}/${logo}`)
    }
    return (
        <div >
            <Button
                id="fade-button"
                aria-controls={open ? 'fade-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                className="menuBtn"

            >
                {/* <MenuIcon className='menu_icon' /><span className='login_menu_txt'> Login Pages</span> */}
                <span className='nav_txt nav_mobile_txt'>{name}<ArrowDropDownIcon className='arrow_icon' /></span>
            </Button>
            <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >

                {obtlist.length > 0 ?
                    obtlist.map((val: any, i: any) => (
                        <MenuItem onClick={() => { handlePayer(val.name); handleRedirectToLogin('/' + val.slug); handleLogo(val.clientlogo) }} key={i} className={storedTheme != 'dark' ? "menuBtn_list" : "menuBtn_list menuBtn_list_dark"} data-testid="health_plan_cards">{val.name}</MenuItem>
                    ))
                    : null}
            </Menu>
        </div>
    );
}
export default MenuBar